var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmiley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 11-6 0 3 3 0 016 0zM20 3a3 3 0 11-6 0 3 3 0 016 0zM5.173 13.38a2 2 0 00-2.347 3.24l2.347-3.24zm12 3.24a2 2 0 00-2.346-3.24l2.347 3.24zM10 15c-1.737 0-3.385-.575-4.827-1.62l-2.347 3.24C4.89 18.113 7.348 19 10 19v-4zm4.826-1.62C13.385 14.425 11.736 15 10 15v4c2.653 0 5.111-.886 7.174-2.38l-2.348-3.24z",
    fill: "#fff"
  })));
}

export default SvgSmiley;